module.exports = __webpack_public_path__ + "static/media/km.86ad579f.svg";